module.exports = __webpack_public_path__ + "static/media/school.02349747.csv";